import type { RevenueOverview } from '@qlk/shared';

import { EmptyState, KhoiMuc, Money, Nut, Skeleton, StatusBadge } from '../../../ui/index.js';
import { useDanhDauDaLienKet } from '../api.js';

/**
 * Khung "Kênh nhận AdSense trực tiếp".
 *
 * Danh sách lấy từ `networks.listAdsenseChannels`. Nút "Đánh dấu đã liên kết"
 * gọi `networks.setAdsenseLinkStatus` — app **chỉ lưu trạng thái**, việc liên
 * kết thật làm thủ công trong YouTube Studio.
 */
export interface KhungAdsenseProps {
  duLieu: RevenueOverview['adsenseChannels'];
  dangTai?: boolean;
  coSua: boolean;
}

export function KhungAdsense({ duLieu, dangTai = false, coSua }: KhungAdsenseProps) {
  const danhDau = useDanhDauDaLienKet();

  return (
    <KhoiMuc
      tieuDe="Kênh nhận AdSense trực tiếp"
      moTa="Liên kết làm trong YouTube Studio; app chỉ theo dõi trạng thái"
    >
      {dangTai ? (
        <Skeleton cao="88px" bo="vua" className="mt-5" />
      ) : duLieu.length === 0 ? (
        <EmptyState
          title="Chưa có kênh nào nhận AdSense trực tiếp"
          description="Gán kênh cho đối tác Google AdSense ở màn hình Network."
        />
      ) : (
        <ul className="mt-5 flex flex-col gap-3">
          {duLieu.map((k) => (
            <li
              key={k.channelId}
              className="flex flex-wrap items-center justify-between gap-3 rounded-[12px] border border-vien p-4"
            >
              <div className="min-w-0">
                <p className="truncate font-semibold text-chu">{k.channelName}</p>
                <p className="text-phu text-chu-mo">
                  Doanh thu kỳ này: <Money value={k.gross} />
                </p>
              </div>

              <div className="flex items-center gap-3">
                <StatusBadge tone={k.linkStatus === 'linked' ? 'ok' : 'warn'}>
                  {k.linkStatus === 'linked' ? 'Đã liên kết' : 'Chờ liên kết'}
                </StatusBadge>
                {coSua && k.linkStatus !== 'linked' && (
                  <Nut
                    dangChay={danhDau.isPending && danhDau.variables === k.channelId}
                    onClick={() => {
                      danhDau.mutate(k.channelId);
                    }}
                  >
                    Đánh dấu đã liên kết
                  </Nut>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}

      {danhDau.error && <p className="mt-3 text-phu text-bad-chu">{danhDau.error.message}</p>}
    </KhoiMuc>
  );
}
